import React from 'react';

export default function HRCopilotFeatures() {
  return (
    <div className="hrcopilot-features-wrapper">
      <style>{`
        .hrcopilot-features-wrapper {
          max-width: 1400px;
          margin: 0 auto;
          padding: 100px 40px;
          margin-top: -190px;
        }

        .hrcopilot-features-headline {
          font-size: 4rem;
          font-weight: 700;
          font-style: italic;
          margin-bottom: 60px;
          color: #1a1a1a;
          line-height: 1.2;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
        }

        .hrcopilot-features-line1 {
          display: block;
          position: relative;
        }

        .hrcopilot-features-circle {
          position: relative;
          display: inline-block;
        }

        .hrcopilot-features-line2 {
          display: block;
          position: relative;
        }

        .hrcopilot-features-underline {
          position: absolute;
          bottom: 8px;
          left: 0;
          width: 140px;
          height: 12px;
          background-color: #4dd4ac;
          z-index: -1;
          border-radius: 4px;
        }

        .hrcopilot-features-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 24px;
        }

        .hrcopilot-features-left {
          display: flex;
          flex-direction: column;
          gap: 24px;
        }

        .hrcopilot-feature-card {
          background-color: white;
          padding: 32px;
          border-radius: 12px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
          position: relative;
        }

        .hrcopilot-feature-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-bottom: 16px;
        }

        .hrcopilot-feature-title {
          font-size: 1.5rem;
          font-weight: 700;
          color: #1a1a1a;
          margin: 0;
        }

        .hrcopilot-feature-star {
          font-size: 2rem;
          color: #fdb755;
          filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.2));
        }

        .hrcopilot-feature-desc {
          font-size: 1.05rem;
          color: #4a4a4a;
          line-height: 1.6;
          margin: 0;
        }

        .hrcopilot-features-right {
          display: flex;
          flex-direction: column;
          gap: 24px;
        }

        .hrcopilot-preview-card {
          background-color: white;
          padding: 32px;
          border-radius: 12px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
          flex: 1;
        }

        .hrcopilot-preview-image {
          width: 100%;
          height: auto;
          border-radius: 8px;
          margin-top: 16px;
          max-width: 400px;
        }

        .hrcopilot-features-cta {
          margin-top: 48px;
          display: flex;
          align-items: center;
          gap: 12px;
          font-size: 1.8rem;
          font-weight: 700;
          font-style: italic;
          color: #1a1a1a;
          cursor: pointer;
          text-decoration: none;
        }

        .hrcopilot-features-arrow {
          font-size: 2.5rem;
          transition: transform 0.3s ease;
        }

        .hrcopilot-features-cta:hover .hrcopilot-features-arrow {
          transform: translateX(8px);
        }

        @media (max-width: 1024px) {
          .hrcopilot-features-grid {
            grid-template-columns: 1fr;
          }

          .hrcopilot-features-headline {
            font-size: 3rem;
          }
        }

        @media (max-width: 768px) {
          .hrcopilot-features-wrapper {
            padding: 60px 20px;
          }

          .hrcopilot-features-headline {
            font-size: 2.5rem;
          }

          .hrcopilot-feature-card {
            padding: 24px;
          }

          .hrcopilot-feature-title {
            font-size: 1.3rem;
          }

          .hrcopilot-feature-desc {
            font-size: 1rem;
          }
        }
      `}</style>

      <h2 className="hrcopilot-features-headline">
        <span className="hrcopilot-features-line1">
          All the <span className="hrcopilot-features-circle">onboarding features</span>
        </span>
        <span className="hrcopilot-features-line2"></span>
      </h2>

      <div className="hrcopilot-features-grid">
        
        {/* LEFT SIDE FEATURES */}
        <div className="hrcopilot-features-left">
          
          <div className="hrcopilot-feature-card">
            <div className="hrcopilot-feature-header">
              <h3 className="hrcopilot-feature-title">A is for Activities</h3>
              <span className="hrcopilot-feature-star">★</span>
            </div>
            <p className="hrcopilot-feature-desc">
              Create onboarding tasks with deadlines — document submissions, training modules, system setup, and more.
            </p>
          </div>

          <div className="hrcopilot-feature-card">
            <div className="hrcopilot-feature-header">
              <h3 className="hrcopilot-feature-title">Automated checklists</h3>
              <span className="hrcopilot-feature-star">★</span>
            </div>
            <p className="hrcopilot-feature-desc">
              Every new hire gets a personalized onboarding checklist automatically generated based on their role.
            </p>
          </div>

          <div className="hrcopilot-feature-card">
            <div className="hrcopilot-feature-header">
              <h3 className="hrcopilot-feature-title">Collect documents</h3>
              <span className="hrcopilot-feature-star">★</span>
            </div>
            <p className="hrcopilot-feature-desc">
              Easily request and track ID proofs, bank details, agreements, and all must-have onboarding documents.
            </p>
          </div>

          <div className="hrcopilot-feature-card">
            <div className="hrcopilot-feature-header">
              <h3 className="hrcopilot-feature-title">Seamless communication</h3>
              <span className="hrcopilot-feature-star">★</span>
            </div>
            <p className="hrcopilot-feature-desc">
              Chat with new hires, send reminders, share policies, and keep everything in one place using the built-in chatter.
            </p>
          </div>
        </div>

        {/* RIGHT SIDE FEATURES */}
        <div className="hrcopilot-features-right">

          <div className="hrcopilot-feature-card">
            <div className="hrcopilot-feature-header">
              <h3 className="hrcopilot-feature-title">Training & orientation</h3>
              <span className="hrcopilot-feature-star">★</span>
            </div>
            <p className="hrcopilot-feature-desc">
              Schedule orientation sessions and assign training modules with calendar integration and automatic tracking.
            </p>
          </div>

          <div className="hrcopilot-preview-card">
            <div className="hrcopilot-feature-header">
              <h3 className="hrcopilot-feature-title">You're onboard!</h3>
              <span className="hrcopilot-feature-star">★</span>
            </div>
            <p className="hrcopilot-feature-desc">
              Once onboarding is completed, convert new hires into fully active employees with one click.
            </p>

            <img 
              src="https://odoocdn.com/openerp_website/static/src/img/apps/hr/onboarding_checklist.webp"
              alt="HR Copilot onboarding preview"
              className="hrcopilot-preview-image"
            />
          </div>
        </div>
      </div>

      <a href="#" className="hrcopilot-features-cta">
        See all onboarding features
        <span className="hrcopilot-features-arrow">→</span>
      </a>
    </div>
  );
}
